const serviceTerms = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "Welcome to [Your Construction Company Name]! By engaging with our services, you agree to our terms and conditions, ensuring a smooth and transparent construction process."
    },
    { 
        id: "acceptable-use", 
        title: "2. Project Scope", 
        content: "All construction projects must align with local building codes and zoning regulations. Any changes in project scope must be requested in writing and may result in additional costs or timeline adjustments."
    },
    {
        id: "contract-terms", 
        title: "3. Contract Terms", 
        content: "All projects are subject to written agreements outlining project timelines, deliverables, costs, and payment schedules. Any delays due to unforeseen circumstances will be communicated promptly."
    },
    { 
        id: "client-responsibilities", 
        title: "4. Client Responsibilities", 
        content: "Clients must ensure the project site is accessible and provide all necessary approvals and permits before construction begins. Delays caused by incomplete permits or site inaccessibility may affect timelines."
    },
    { 
        id: "material-standards", 
        title: "5. Material & Quality Standards", 
        content: "All materials used in construction will meet or exceed industry standards. Any material substitutions will require client approval. We are not responsible for defects caused by third-party suppliers."
    },
    { 
        id: "cancellation", 
        title: "6. Cancellation & Refunds", 
        content: "Cancellations must be requested before the project starts. Refunds are subject to the contract terms and any work already completed. Deposits may be non-refundable."
    },
    { 
        id: "warranties", 
        title: "7. Warranties & Defects", 
        content: "We provide a warranty on workmanship for [X] years. If any structural issues arise within this period due to our construction, we will repair them at no cost. Damage due to external factors is not covered."
    },
    { 
        id: "governing-law", 
        title: "8. Compliance & Regulations", 
        content: "All construction work complies with local and national building regulations. Any legal disputes will be handled under the jurisdiction of [Your City/Region]."
    },
    { 
        id: "contact-info", 
        title: "9. Contact Information", 
        content: "For inquiries, reach us at support@[companyname].com or call +[Phone Number]."
    }
];

export default serviceTerms;